import React, { useState } from "react";
import { Button, Menu, Dropdown, Modal } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import EditProfessionalProfile from "../EditProfessionalProfile";

import { useDispatch, useSelector } from "react-redux";
import { deleteProfessionalProfile } from "redux/actions";
import PropTypes from "prop-types";
import { usePermissions } from "lib/permissionHook";
import ShowProfessionalProfile from "../ShowProfessionalProfile";
import ModalCloseConfirm from "lib/components/ModalCloseConfirm";
import ModalDeleteConfirm from "lib/components/ModalDeleteConfirm";
import { AiOutlineClose } from "react-icons/ai";

const MODULE_NAME = "PROFESSIONAL PROFILE";
function ProfessionalProfileTableActions({ data }) {
  const { messages } = useIntl();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isShowModalVisible, setIsShowModalVisible] = useState(false);

  const { profile } = useSelector(({ profile }) => profile);
  const permission = usePermissions(MODULE_NAME, profile);

  const dispatch = useDispatch();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showShowModal = () => {
    setIsShowModalVisible(true);
  };

  const handleShowOk = () => {
    setIsShowModalVisible(false);
  };

  const handleShowCancel = () => {
    setIsShowModalVisible(false);
  };

  const handleDelete = () => {
    const payload = {
      professionalProfileId: data._id,
    };
    dispatch(deleteProfessionalProfile(payload));
  };

  const menu = (
    <Menu>
      <Menu.Item style={{ fontSize: 14 }} onClick={showShowModal}>
        View
      </Menu.Item>
      <Menu.Item
        style={{ fontSize: 14 }}
        onClick={showModal}
        disabled={permission && !permission.update && !profile.isSuperAdmin}
      >
        Edit
      </Menu.Item>
      <Menu.Item
        style={{ fontSize: 14 }}
        disabled={permission && !permission.delete && !profile.isSuperAdmin}
      >
        {permission && !permission.delete && !profile.isSuperAdmin ? (
          "Delete"
        ) : (
          <ModalDeleteConfirm handleDelete={handleDelete} />
        )}
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]}>
        <Button type="circle">
          <MoreOutlined />
        </Button>
      </Dropdown>

      <Modal
        title={messages["admin.editProfessionalProfile"]}
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        maskClosable={false}
        destroyOnClose={true}
        closeIcon={<ModalCloseConfirm onCancel={handleCancel} />}
      >
        <EditProfessionalProfile data={data} closeModel={handleCancel} />
      </Modal>

      <Modal
        title={messages["admin.showProfessionalProfile"]}
        visible={isShowModalVisible}
        onOk={handleShowOk}
        footer={false}
        maskClosable={false}
        destroyOnClose={true}
        closeIcon={<AiOutlineClose onClick={handleShowCancel} />}
      >
        <ShowProfessionalProfile professionalProfile={data} />
      </Modal>
    </>
  );
}

export default ProfessionalProfileTableActions;

ProfessionalProfileTableActions.propTypes = {
  data: PropTypes.object,
};
